import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import {useNavigate} from 'react-router';
import React, { useEffect } from 'react';
import Table from '@mui/material/Table';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {EM_OTHER, EM_NEW} from './Util';
import {getCityName} from './Trans'
import {COMM_OK} from './WsR2.js';
import ObsAppBar from './AppBar';

const UserList = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const navigate = useNavigate();
	let force_back = 0;

	useEffect(() => {
		/* Ask info (for changes in user_time)! */
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'list',
		}

		gStorage.conn.ws.send(msg, userListRxWs);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (force_back) {
			navigate('/');
		}
		// eslint-disable-next-line
	}, [force_back]);

	function userListRxWs(status, obj) {
		if (status !== COMM_OK) {
			console.error('userListRxWs: error', status);
			return;
		}

		if (obj.cmd === 'user') {
			if (obj.op === 'list') {
				if (obj.result === 'OK') {
// 					console.log('userListRxWs: user list:', gStorage.lists.userlist.list);

					gStorage.lists.setUserList({last_upd: gStorage.srv.info.user_time, list: obj.data.userlist});
				} else {
					console.error('userListRxWs: user list cmd failed ' + obj.data.desc + '!');
				}
			} else {
				console.error('statRxWs: unknown user operation ' + obj.op + '!');
			}
		} else {
			console.error('userListRxWs: unknown command', obj.cmd);
		}
	}

	function getheader() {
		return t('admin.users');
	}

	function userGetCityName(id) {
		return getCityName(gStorage.lists.citylist.list.find(elem => elem.id === id), gStorage.conn.user);
	}
	
	function editUser(value) {
// 		console.log('editUser', value);

		gStorage.settings.setEditId(value);
		gStorage.settings.setEditMode(EM_OTHER);
		navigate('/settings');
	}

	function toAddUser(value) {
		gStorage.settings.setEditMode(EM_NEW);
		navigate('/settings');
	}

	if (!gStorage.conn.online || !gStorage.conn.user._access || force_back) {
		console.error('UserList: unprivileged operator!');
		force_back = 1;
		return null;
	}

	return (
		<div>
			<ObsAppBar {...props} getheader={getheader} add_action={toAddUser}/>
			<Table size='small'>
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>{t('common.name')}</TableCell>
						<TableCell>{t('settings.city')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{gStorage.lists.userlist.list.map((user) => {
						let bg;

						bg = user.no_login ? '#fa8072' : '#ffffff';

						return (
							<TableRow onClick={editUser.bind(this, user.id)} style={{backgroundColor: bg, cursor: 'pointer'}} key={user.id}>
								<TableCell>{user.nick}</TableCell>
								<TableCell>{user.last_name + ' ' + user.first_name}</TableCell>
								<TableCell>{userGetCityName(user.city_id)}</TableCell>
							</TableRow>);
						})
					}
				</TableBody>
			</Table>
		</div>
	);
});

export default UserList;
